<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1111 1V4.2M5.88889 1V4.2M2 8H16M3.55556 3H14.4444C15.3036 3 16 3.71634 16 4.6V15.4C16 16.2837 15.3036 17 14.4444 17H3.55556C2.69645 17 2 16.2837 2 15.4V4.6C2 3.71634 2.69645 3 3.55556 3Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CalendarIcon',
  };
</script>
